<template>
    <div>
        <div class="nk-block-head nk-block-head-sm">
            <div class="nk-block-between align-items-start">
                <div class="nk-block-head-content">
                    <h3 class="nk-block-title page-title">{{trans('ip_filter.edit_ip_filter')}}</h3>
                    <div class="nk-block-des text-soft">
                        <p>Adjust a single IP range and description before returning to the access rule list.</p>
                    </div>
                </div>
                <router-link to="/configuration/ip-filter" class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--outline">{{trans('general.back')}}</router-link>
            </div>
        </div>

        <div class="admin-config-layout admin-linear-page">
            <configuration-sidebar menu="ip-filter"></configuration-sidebar>
            <div class="admin-config-panel">
                <div class="admin-config-panel__inner">
                    <section class="admin-config-section" :aria-label="trans('ip_filter.edit_ip_filter')">
                        <ip-filter-form :id="id"></ip-filter-form>
                    </section>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import configurationSidebar from '../system-config-sidebar'
    import ipFilterForm from './form';

    export default {
        components : { configurationSidebar, ipFilterForm },
        data() {
            return {
                id:this.$route.params.id
            }
        },
        mounted(){
            if(!helper.hasPermission('access-configuration')){
                helper.notAccessibleMsg();
                this.$router.push('/home');
            }

            if(!helper.featureAvailable('ip_filter')){
                helper.featureNotAvailableMsg();
                this.$router.push('/home');
            }
        }
    }
</script>

<style scoped>
.admin-linear-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1.25rem;
    margin-bottom: 1.25rem;
    padding: 1.1rem 1.2rem;
    border: 1px solid var(--dash-pro-border);
    border-radius: var(--dash-pro-radius-sm);
    background: linear-gradient(135deg, rgba(99, 102, 241, 0.06), var(--dash-pro-surface));
}

.admin-linear-head__eyebrow,
.admin-linear-section-label {
    display: block;
    color: var(--lms-primary);
    font-size: 0.68rem;
    font-weight: 800;
    letter-spacing: 0.09em;
    text-transform: uppercase;
}

.admin-linear-head__title {
    margin: 0.35rem 0 0;
    color: var(--dash-pro-text);
    font-size: 1.35rem;
    font-weight: 700;
    letter-spacing: -0.04em;
}

.admin-linear-head__description {
    max-width: 42rem;
    margin: 0.45rem 0 0;
    color: var(--dash-pro-muted);
    font-size: 0.875rem;
    line-height: 1.55;
}

.admin-linear-section-label {
    margin-bottom: 0.35rem;
}

@media (max-width: 575.98px) {
    .admin-linear-head {
        flex-direction: column;
    }
}
</style>
